import { DateTimeWithPrecision } from "@/Common/Models/DateTimeWithPrecision";
import { NonFunctionProperties } from "@/Common/Models/NonFunctionProperties";
import { CareElementFrequencyType } from "../CareElementFrequencyType";
import { CareElementOperatorType } from "../CareElementOperatorType";
import { BaseCareElement } from "./BaseCareElement";
import { CareElementType } from "./CareElementType";

export class BooleanReviewedCareElement extends BaseCareElement {
    public Name: string;
    public CareElementType: CareElementType.BooleanReviewed;
    public Value?: boolean | null;
    public Target?: boolean | null;
    public DateReviewed?: Date | null;
    public LastReviewedDate?: Date | null;
    public Frequency?: CareElementFrequencyType;
    public Operator?: CareElementOperatorType;
    public DateReviewedWithPrecision?: DateTimeWithPrecision | null;

    public constructor(init?: Omit<NonFunctionProperties<BooleanReviewedCareElement>, "CareElementType">) {
        super();
        this.Name = init?.Name ?? "";
        this.CareElementType = CareElementType.BooleanReviewed;
        this.Value = init?.Value ?? null;
        this.Target = init?.Target ?? null;
        this.SubSectionName = init?.SubSectionName ?? "";
        this.DateReviewed = init?.DateReviewed ?? null;
        this.LastReviewedDate = init?.LastReviewedDate ?? null;
        this.Frequency = init?.Frequency ?? null;
        this.Operator = init?.Operator ?? null;
        this.DateReviewedWithPrecision = init.DateReviewedWithPrecision ?? DateTimeWithPrecision.getDate(init?.DateReviewed);
    }
}
